import { render, staticRenderFns } from "./CodemirrorLineNumbersBtn.vue?vue&type=template&id=c1c9ac6c"
import script from "./CodemirrorLineNumbersBtn.vue?vue&type=script&setup=true&lang=js"
export * from "./CodemirrorLineNumbersBtn.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports